import React, { useEffect, useState } from 'react'
import { usePlanLapse } from '@/hooks/usePlanLapse'
import { createPortal } from 'react-dom'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import {
  PaperPlaneTilt,
  Play,
  Pause,
  DotsThree,
  Trash,
  Eye,
  UsersThree,
  Envelope,
  CursorClick,
  ArrowBendUpLeft,
  CircleNotch,
  Rocket,
  // Sparkle,  // DISABLED with Suggested campaigns
  // FileText,  // DISABLED with Suggested campaigns
  // Sword,  // DISABLED with Suggested campaigns
  // Megaphone,  // DISABLED with Suggested campaigns
  // ArrowRight,  // DISABLED with Suggested campaigns
  CaretLeft,
  CaretRight,
  ArrowsClockwise,
  // UserPlus,  // DISABLED with Suggested campaigns
  // Newspaper,  // DISABLED with Suggested campaigns
  Calendar,
  WarningCircle,
  // Gift,  // DISABLED with Suggested campaigns
  // TrendUp,  // DISABLED with Suggested campaigns
  // type Icon as PhosphorIcon,  // DISABLED with Suggested campaigns
} from '@phosphor-icons/react'
import { Card, CardContent } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { Select } from '@/components/ui/Select'
import { Tooltip } from '@/components/ui/Tooltip'
import { useCampaignStore } from '@/stores/campaignStore'
import { usePermission } from '@/hooks/usePermission'
import { useTrialStatus } from '@/hooks/useTrialStatus'
// DISABLED with Suggested campaigns.
// import { campaignsApi } from '@/lib/api'
import { formatDistanceToNow } from 'date-fns'
import { badgeVariantIconTint, cn } from '@/lib/utils'
import { campaignStatusMeta } from '@/lib/campaignStatus'
import LaunchCampaignModal from './LaunchCampaignModal'
import AICampaignWizard from './AICampaignWizard'

const PAGE_SIZE = 10

// Built-in starting points, shown **labelled as such** when the AI suggestion
// endpoint is unavailable or returns nothing. They used to be swapped in
// silently under the "Suggested campaigns" heading, so a user could not tell a
// personalised suggestion from a canned one (H1.2).
  // DISABLED with Suggested campaigns
// const FALLBACK_SUGGESTIONS = [
//   { title: 'Cold Outreach Sequence', description: 'Professional multi-step cold email sequence for B2B prospects', icon_type: 'introduction', prompt: 'Create a professional 3-email cold outreach sequence for B2B prospects. Include an introduction email, a follow-up with value proposition, and a final touch with urgency. Professional tone.' },
//   { title: 'Product Launch Announcement', description: 'Announce a new product or feature to your contact list', icon_type: 'product', prompt: 'Create a 3-email product launch campaign. Email 1: teaser/anticipation, Email 2: launch day announcement with details, Email 3: follow-up with social proof. Excited yet professional tone.' },
//   { title: 'Re-engagement Campaign', description: 'Win back contacts who went silent', icon_type: 're_engagement', prompt: 'Create a 3-email re-engagement campaign for contacts who haven\'t responded to previous outreach. Use a fresh angle, acknowledge the silence without being pushy, and provide new value. Friendly tone.' },
//   { title: 'Newsletter Welcome Series', description: 'Onboard new subscribers with a warm welcome sequence', icon_type: 'onboarding', prompt: 'Create a 3-email welcome series for new subscribers. Email 1: warm welcome + what to expect, Email 2: best resources/content, Email 3: personal touch + invite to connect. Friendly and helpful tone.' },
//   { title: 'Event Invitation', description: 'Drive registrations for a webinar, demo, or event', icon_type: 'event', prompt: 'Create a 3-email event invitation campaign for a webinar or demo. Email 1: invitation with value prop, Email 2: reminder with speaker/agenda details, Email 3: last chance urgency. Enthusiastic tone.' },
//   { title: 'Customer Success Story', description: 'Share a success story to build credibility with prospects', icon_type: 'case_study', prompt: 'Create a 3-email campaign sharing a customer success story. Email 1: introduce the challenge, Email 2: reveal the solution and results, Email 3: invite similar prospects to learn more. Persuasive tone with real metrics.' },
//   { title: 'Referral Request', description: 'Ask happy customers for introductions and referrals', icon_type: 'referral', prompt: 'Create a 3-email referral campaign targeting existing happy customers. Email 1: appreciate their business + soft ask, Email 2: specific referral request with incentive, Email 3: gentle reminder. Warm and grateful tone.' },
//   { title: 'Competitive Comparison', description: 'Highlight your advantages over competitors', icon_type: 'competitive', prompt: 'Create a 3-email campaign highlighting competitive advantages. Email 1: industry challenge, Email 2: how we solve it better, Email 3: proof points and CTA. Confident but not aggressive tone.' },
// ]

// Suggestion category icons — palette restrained to Editorial Dark tokens (indigo accent /
// amber attention / emerald positive / muted neutral). Per §3 + §11: no rainbow.
// type SuggestionTint = { icon: PhosphorIcon; iconColor: string; bgColor: string; glow: string }
// `glow` is a soft top-right ambient applied behind the tile content via radial-gradient.
// Keeps depth without violating the indigo+amber palette commitment (§3).
// const INDIGO_TINT  = { iconColor: 'text-[#5e6ad2] dark:text-[#a5b4fc]',     bgColor: 'bg-[#5e6ad2]/10 dark:bg-[#5e6ad2]/[0.12]',     glow: 'radial-gradient(circle at top right, rgba(94,106,210,0.16), transparent 65%)' }
// const EMERALD_TINT = { iconColor: 'text-emerald-600 dark:text-emerald-400', bgColor: 'bg-emerald-500/10 dark:bg-emerald-500/[0.10]', glow: 'radial-gradient(circle at top right, rgba(16,185,129,0.14), transparent 65%)' }
// const AMBER_TINT   = { iconColor: 'text-amber-600 dark:text-amber-400',     bgColor: 'bg-amber-500/10 dark:bg-amber-500/[0.10]',    glow: 'radial-gradient(circle at top right, rgba(245,165,36,0.16), transparent 65%)' }
// const NEUTRAL_TINT = { iconColor: 'text-muted-foreground dark:text-[#8a8f98]', bgColor: 'bg-muted/60 dark:bg-white/[0.04]',        glow: 'radial-gradient(circle at top right, rgba(94,106,210,0.10), transparent 65%)' }

  // DISABLED with Suggested campaigns
// const iconMap: Record<string, SuggestionTint> = {
//   case_study:     { icon: FileText,    ...INDIGO_TINT },
//   competitive:    { icon: Sword,       ...AMBER_TINT },
//   product:        { icon: Megaphone,   ...INDIGO_TINT },
//   content:        { icon: FileText,    ...INDIGO_TINT },
//   introduction:   { icon: UserPlus,    ...EMERALD_TINT },
//   re_engagement:  { icon: Envelope,    ...AMBER_TINT },
//   newsletter:     { icon: Newspaper,   ...INDIGO_TINT },
//   event:          { icon: Calendar,    ...AMBER_TINT },
//   seasonal:       { icon: Gift,        ...NEUTRAL_TINT },
//   upsell:         { icon: TrendUp,     ...EMERALD_TINT },
//   referral:       { icon: UsersThree,  ...INDIGO_TINT },
//   onboarding:     { icon: Rocket,      ...EMERALD_TINT },
// }
// const fallbackIcon: SuggestionTint = { icon: Sparkle, ...INDIGO_TINT }

const CampaignsPage: React.FC = () => {
  const navigate = useNavigate()
  const {
    campaigns, stats, isLoading,
    fetchCampaigns, fetchStats,
    deleteCampaign, launchCampaign,
    pauseCampaign, resumeCampaign,
    members, ranByUserId, fetchMembers, setRanByFilter,
  } = useCampaignStore()
  const { allowed: canLaunch, scope: launchScope } = usePermission('campaigns', 'launch')
  const { lapsed: planLapsed, reason: lapsedTitle } = usePlanLapse()
  const { isTrial, limits: trialLimits } = useTrialStatus()
  // "gated" = a Rep, who may only REQUEST a launch. They keep the action (the
  // request has to start somewhere) but the wording must not promise a send.
  const launchIsRequest = canLaunch && launchScope === 'gated'
  const { allowed: canPauseStop } = usePermission('campaigns', 'pause_stop')
  // "Ran by" team filter: only account-wide scopes (Owner/Admin/Manager "all",
  // Analyst "view") may see teammates' campaigns — a Rep's scope is "own", so
  // the dropdown is hidden for them and the API rejects the param anyway.
  const { scope: campaignScope } = usePermission('campaigns', 'create')
  const canFilterByMember = campaignScope !== null && campaignScope !== 'own'
  const [openMenu, setOpenMenu] = useState<number | null>(null)
  const [menuCoords, setMenuCoords] = useState<{ top: number; right: number } | null>(null)
  const [pendingDeleteId, setPendingDeleteId] = useState<number | null>(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [showLaunchModal, setShowLaunchModal] = useState(false)
  const [showAIWizard, setShowAIWizard] = useState(false)
  const [aiInitialPrompt, setAiInitialPrompt] = useState<string | undefined>(undefined)
  // const [suggestions, setSuggestions] = useState<{ title: string; description: string; icon_type: string; prompt: string }[]>([])
  // const [suggestionsLoading, setSuggestionsLoading] = useState(true)
  // Which set is on screen — 'ai' came back from the endpoint, 'starter' is the
  // local fallback. Drives the heading so the two are never conflated.
  // const [suggestionsSource, setSuggestionsSource] = useState<'ai' | 'starter'>('ai')
  const [pendingLaunchId, setPendingLaunchId] = useState<number | null>(null)
  const [isLaunching, setIsLaunching] = useState(false)
  const [page, setPage] = useState(1)

  const goToPage = (p: number) => {
    setPage(p)
    fetchCampaigns((p - 1) * PAGE_SIZE, PAGE_SIZE)
  }

  // DISABLED — the /campaigns/ai-generate/suggestions route is
  // unregistered on the backend, so this would 404 on every page load.
  // Kept as a no-op stub; restore the body with the section above.
  const loadSuggestions = () => {}
  // const loadSuggestions = () => {
  // setSuggestionsLoading(true)
  // campaignsApi.aiSuggestions()
  // .then(r => {
  // const list = r.data.suggestions
  // if (list?.length) {
  // setSuggestions(list)
  // setSuggestionsSource('ai')
  // } else {
  // setSuggestions(FALLBACK_SUGGESTIONS)
  // setSuggestionsSource('starter')
  // }
  // })
  // .catch(() => {
  // setSuggestions(FALLBACK_SUGGESTIONS)
  // setSuggestionsSource('starter')
  // })
  // .finally(() => setSuggestionsLoading(false))
  // }

  useEffect(() => {
    fetchCampaigns(0, PAGE_SIZE)
    fetchStats()
    loadSuggestions()
    if (canFilterByMember) fetchMembers()
  }, [canFilterByMember])

  const handleRanByChange = (value: string) => {
    setRanByFilter(value === 'all' ? null : Number(value))
    setPage(1)
    fetchCampaigns(0, PAGE_SIZE)
    fetchStats()
  }

  const handleDelete = (id: number) => {
    setOpenMenu(null)
    setMenuCoords(null)
    setPendingDeleteId(id)
  }

  const confirmDelete = async () => {
    if (pendingDeleteId == null) return
    setIsDeleting(true)
    try {
      await deleteCampaign(pendingDeleteId)
      await fetchStats()
      // Reload the current page (backfills from the next page), stepping back
      // if the page we're on no longer exists after the delete.
      const newTotal = useCampaignStore.getState().stats.total
      const lastPage = Math.max(1, Math.ceil(newTotal / PAGE_SIZE))
      goToPage(Math.min(page, lastPage))
      setPendingDeleteId(null)
    } catch {
      // The store already toasted the reason. Swallowing keeps the rejection
      // from going unhandled and leaves the dialog open so the user can retry.
    } finally {
      setIsDeleting(false)
    }
  }

  const toggleMenu = (campaignId: number, e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (openMenu === campaignId) {
      setOpenMenu(null)
      setMenuCoords(null)
      return
    }
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
    setMenuCoords({ top: rect.bottom + 6, right: window.innerWidth - rect.right })
    setOpenMenu(campaignId)
  }

  const closeMenu = () => {
    setOpenMenu(null)
    setMenuCoords(null)
  }

  // Dismissal per §19 + §54: scroll, resize and Escape.
  useEffect(() => {
    if (openMenu == null) return
    const onDismiss = () => closeMenu()
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeMenu()
    }
    window.addEventListener('scroll', onDismiss, true)
    window.addEventListener('resize', onDismiss)
    document.addEventListener('keydown', onKey)
    return () => {
      window.removeEventListener('scroll', onDismiss, true)
      window.removeEventListener('resize', onDismiss)
      document.removeEventListener('keydown', onKey)
    }
  }, [openMenu])

  // Starting a send is irreversible — mail leaves the building — so it goes
  // through ConfirmDialog (§16) like every other unrecoverable action.
  const requestLaunch = (id: number) => {
    closeMenu()
    setPendingLaunchId(id)
  }

  const confirmLaunch = async () => {
    if (pendingLaunchId == null) return
    setIsLaunching(true)
    try {
      await launchCampaign(pendingLaunchId)
      await fetchStats()
      setPendingLaunchId(null)
    } catch {
      // store already toasted the backend's reason
    } finally {
      setIsLaunching(false)
    }
  }

  const handlePause = async (id: number) => {
    closeMenu()
    try {
      await pauseCampaign(id)
      fetchStats()
    } catch {
      // store already toasted
    }
  }

  const handleResume = async (id: number) => {
    closeMenu()
    try {
      await resumeCampaign(id)
      fetchStats()
    } catch {
      // store already toasted
    }
  }

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1
            className="text-foreground dark:text-[#f7f8f8]"
            style={{ fontSize: '24px', fontWeight: 590, letterSpacing: '-0.288px', lineHeight: 1.33 }}
          >
            Campaigns
          </h1>
          <p
            className="text-muted-foreground dark:text-[#8a8f98] mt-1"
            style={{ fontSize: '13px', letterSpacing: '-0.13px', lineHeight: 1.5 }}
          >
            Schedule, launch, and monitor your email campaigns.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* DISABLED — AI campaign generation is switched off alongside
              the Suggested campaigns section below. */}
          {/*
          <Button
            variant="outline"
            size="sm"
            icon={<Sparkle className="h-4 w-4" weight="regular" />}
            onClick={() => setShowAIWizard(true)}
          >
            AI Generate
          </Button>
          */}
          {/* This opens a *scheduling* wizard whose submit produces status
              `scheduled` — it does not start sending. "Launch now" is the row
              action that does, and "Resume" restarts a paused one. Three
              different acts, three different words. */}
          {/* A Rep's own campaigns are "gated": launching is a request, not
              an action, until an Owner/Admin/Manager approves it elsewhere.
              This list is a Rep's only way to see the status flip from
              "Pending approval" to "Sending"/"Sent" without leaving the
              page and coming back. Nobody else needs it -- everyone else
              launches outright and sees the result of their own click. */}
          {launchScope === 'gated' && (
            <Button
              variant="outline"
              size="sm"
              loading={isLoading}
              onClick={() => fetchCampaigns((page - 1) * PAGE_SIZE, PAGE_SIZE)}
              icon={<ArrowsClockwise className="h-4 w-4" weight="regular" />}
              aria-label="Refresh campaign list"
            >
              Refresh
            </Button>
          )}
          {canLaunch && (
            <Button
              variant="default"
              size="sm"
              icon={<Calendar className="h-4 w-4" weight="regular" />}
              onClick={() => setShowLaunchModal(true)}
              disabled={planLapsed}
              title={lapsedTitle}
            >
              Launch campaign
            </Button>
          )}
        </div>
      </div>

      {/* Free-trial cap, proactive — only ever shown to a trial account. */}
      {isTrial && trialLimits && (
        <p
          className="text-muted-foreground dark:text-[#8a8f98]"
          style={{ fontSize: '11px', letterSpacing: '-0.05px' }}
        >
          {stats.total} of {trialLimits.campaigns} campaigns used (free trial)
        </p>
      )}

      {/* Hero stats block — title + decorative outbound-orbit SVG + floating stat pills */}
      <section
        className={cn(
          'relative overflow-hidden rounded-2xl border border-border/50 p-5 sm:p-6',
          'bg-gradient-to-br from-white via-[#f6f7ff] to-[#eef0ff]',
          'dark:border-white/[0.08] dark:from-[#0f1011] dark:via-[#131421] dark:to-[#1a1b2e]',
        )}
      >
        {/* Decoration — concentric broadcast rings anchored off the top-right edge.
            Abstract, geometric, no literal glyph. Reads as "send / reach". */}
        <div
          className="pointer-events-none absolute inset-0 overflow-hidden text-[#7170ff] dark:text-[#7170ff]"
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 560 240"
            preserveAspectRatio="xMaxYMid slice"
            className="absolute inset-0 h-full w-full"
          >
            <defs>
              <radialGradient id="cp-hub-glow" cx="92%" cy="-10%" r="55%">
                <stop offset="0%"  stopColor="currentColor" stopOpacity="0.22" />
                <stop offset="55%" stopColor="currentColor" stopOpacity="0.06" />
                <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
              </radialGradient>
            </defs>

            {/* Soft indigo halo behind the rings */}
            <rect width="100%" height="100%" fill="url(#cp-hub-glow)" />

            {/* Concentric rings — center anchored just off the upper-right corner so
                only the lower-left quadrant of each ring is visible inside the panel.
                Stroke opacity steps down with distance, creating a clean radial fade. */}
            <g fill="none" stroke="currentColor" strokeLinecap="round">
              <circle cx="520" cy="-20" r="80"  strokeOpacity="0.32" strokeWidth="1" />
              <circle cx="520" cy="-20" r="140" strokeOpacity="0.22" strokeWidth="1" />
              <circle cx="520" cy="-20" r="210" strokeOpacity="0.14" strokeWidth="1" />
              <circle cx="520" cy="-20" r="290" strokeOpacity="0.08" strokeWidth="1" />
              <circle cx="520" cy="-20" r="380" strokeOpacity="0.04" strokeWidth="1" />
            </g>
          </svg>
        </div>

        {/* Title */}
        <div className="relative z-10 max-w-md">
          <h2
            className="text-foreground dark:text-[#f7f8f8]"
            style={{ fontSize: '20px', fontWeight: 590, letterSpacing: '-0.24px', lineHeight: 1.3 }}
          >
            Campaign pipeline
          </h2>
          <p
            className="text-muted-foreground dark:text-[#8a8f98] mt-1"
            style={{ fontSize: '12px', letterSpacing: '-0.1px', lineHeight: 1.5 }}
          >
            Track delivery, engagement, and what's queued at a glance.
          </p>
        </div>

        {/* Stat pills — float over the decoration. The three state counts read
            their glyph and tint from the §60 map, so the hero can never
            disagree with the row chips 200 lines below it. "Total" is an
            aggregate rather than a state, so it stays neutral. */}
        <div className="relative z-10 mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { label: 'Total', value: stats.total, icon: PaperPlaneTilt, iconNudge: '', color: badgeVariantIconTint.default.fg, bg: badgeVariantIconTint.default.bg },
            ...(['running', 'scheduled', 'completed'] as const).map((key) => {
              const meta = campaignStatusMeta(key)
              return { label: meta.label, value: stats[key], icon: meta.Icon, iconNudge: meta.iconNudge, color: meta.iconTint.fg, bg: meta.iconTint.bg }
            }),
          ].map((stat) => (
            <div
              key={stat.label}
              className={cn(
                'rounded-xl border bg-white px-4 py-5 transition-colors duration-150',
                'border-border/40 shadow-[0_1px_2px_rgba(15,16,17,0.04),0_4px_12px_rgba(15,16,17,0.04)]',
                'dark:bg-[#191a1b]/85 dark:backdrop-blur-sm dark:border-white/[0.08] dark:shadow-[0_1px_2px_rgba(0,0,0,0.4),0_8px_24px_rgba(0,0,0,0.25)]',
              )}
            >
              <p
                className="text-foreground dark:text-[#f7f8f8] tabular-nums"
                style={{ fontSize: '28px', fontWeight: 590, letterSpacing: '-0.5px', lineHeight: 1.05 }}
              >
                {stat.value}
              </p>
              <div className="mt-2.5 flex items-center gap-2">
                <div
                  className={cn('h-6 w-6 rounded-md flex items-center justify-center flex-shrink-0', stat.bg)}
                  aria-hidden="true"
                >
                  <stat.icon className={cn('h-3.5 w-3.5', stat.color, stat.iconNudge)} weight="regular" />
                </div>
                <p
                  className="text-muted-foreground dark:text-[#8a8f98]"
                  style={{ fontSize: '12px', fontWeight: 510, letterSpacing: '-0.1px' }}
                >
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* DISABLED — "Suggested campaigns" is switched off. The whole
          section (heading, skeletons, suggestion tiles and the starter
          fallback) is commented out, and the backend
          /campaigns/ai-generate/suggestions route is unregistered.
          Re-enable with loadSuggestions() and the AI Generate button. */}
      {/*
      { /* AI Suggestions — or, when the endpoint gave us nothing, the local
          starter set, said out loud rather than passed off as generated. * /}
      <div>
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          {suggestionsSource === 'ai' ? (
            <Sparkle className="h-4 w-4 text-[#5e6ad2] dark:text-[#a5b4fc]" weight="regular" />
          ) : (
            <FileText className="h-4 w-4 text-muted-foreground dark:text-[#8a8f98]" weight="regular" />
          )}
          <h2
            className="text-foreground dark:text-[#f7f8f8]"
            style={{ fontSize: '13px', fontWeight: 590, letterSpacing: '-0.13px' }}
          >
            {suggestionsSource === 'ai' ? 'Suggested campaigns' : 'Starter campaigns'}
          </h2>
          {suggestionsSource === 'starter' && !suggestionsLoading && (
            <span className="flex items-center gap-2" role="status">
              <span
                className="text-muted-foreground dark:text-[#8a8f98]"
                style={{ fontSize: '12px', letterSpacing: '-0.1px' }}
              >
                · Built-in starting points — personalised suggestions weren't available.
              </span>
              <button
                type="button"
                onClick={loadSuggestions}
                className="rounded-md px-1.5 py-0.5 text-[#5e6ad2] hover:bg-[#5e6ad2]/[0.08] dark:text-[#a5b4fc] dark:hover:bg-[#5e6ad2]/[0.12] transition-colors duration-100"
                style={{ fontSize: '12px', fontWeight: 510, letterSpacing: '-0.1px' }}
              >
                Retry
              </button>
            </span>
          )}
        </div>
        {suggestionsLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="p-4 rounded-lg border border-border/50 dark:border-white/[0.08] dark:bg-white/[0.02] animate-pulse">
                <div className="flex items-start gap-3">
                  <div className="h-9 w-9 rounded-md bg-muted/60 dark:bg-white/[0.04] shrink-0" />
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-muted/60 dark:bg-white/[0.04] rounded w-3/4" />
                    <div className="h-3 bg-muted/40 dark:bg-white/[0.03] rounded w-full" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : suggestions.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            {suggestions.map((s, i) => {
              const { icon: Icon } = iconMap[s.icon_type] || fallbackIcon
              return (
                <motion.button
                  key={i}
                  type="button"
                  onClick={() => { setAiInitialPrompt(s.prompt); setShowAIWizard(true) }}
                  whileTap={{ scale: 0.98 }}
                  className="group relative overflow-hidden text-left p-4 rounded-lg border border-border/50 bg-card hover:border-[#5e6ad2]/30 hover:bg-[#5e6ad2]/[0.03] dark:border-white/[0.08] dark:bg-white/[0.02] dark:hover:border-[#7170ff]/30 dark:hover:bg-white/[0.04] transition-colors duration-150"
                >
                  { /* Unified brand-indigo ambient — same on every card so the
                      row reads as one family; icon chip alone carries category. * /}
                  <span
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-0 opacity-90 dark:opacity-70"
                    style={{
                      backgroundImage:
                        'linear-gradient(135deg, rgba(94,106,210,0.10) 0%, rgba(94,106,210,0.04) 45%, transparent 75%)',
                    }}
                  />
                  <div className="relative flex items-start gap-3">
                    { /* Unified indigo chip — same on every card; icon glyph
                        alone signals category. * /}
                    <div className="h-9 w-9 rounded-md flex items-center justify-center shrink-0 bg-[#5e6ad2]/[0.10] dark:bg-[#5e6ad2]/[0.14] border border-[#5e6ad2]/20 dark:border-[#5e6ad2]/25">
                      <Icon className="h-4 w-4 text-[#5e6ad2] dark:text-[#a5b4fc]" weight="regular" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3
                        className="text-foreground dark:text-[#f7f8f8] mb-0.5 group-hover:text-[#5e6ad2] dark:group-hover:text-[#a5b4fc] transition-colors"
                        style={{ fontSize: '14px', fontWeight: 590, letterSpacing: '-0.13px' }}
                      >
                        {s.title}
                      </h3>
                      <p
                        className="text-muted-foreground dark:text-[#8a8f98] line-clamp-2"
                        style={{ fontSize: '12px', lineHeight: 1.55, letterSpacing: '-0.1px' }}
                      >
                        {s.description}
                      </p>
                    </div>
                    <ArrowRight
                      className="h-4 w-4 text-muted-foreground/40 dark:text-[#3e3e44] group-hover:text-[#5e6ad2] dark:group-hover:text-[#a5b4fc] shrink-0 mt-0.5 transition-colors"
                      weight="bold"
                    />
                  </div>
                </motion.button>
              )
            })}
          </div>
        ) : null}
      </div>
      */}

      {/* "Ran by" team filter — hidden for own-scoped roles (Rep) and for
          solo accounts where there is no one to filter by. */}
      {canFilterByMember && members.length > 1 && (
        <div className="flex items-center gap-2">
          <span
            className="text-muted-foreground dark:text-[#8a8f98] flex-shrink-0"
            style={{ fontSize: '13px', letterSpacing: '-0.13px' }}
          >
            Ran by
          </span>
          <Select
            ariaLabel="Filter campaigns by team member"
            className="w-56"
            value={ranByUserId === null ? 'all' : String(ranByUserId)}
            onChange={handleRanByChange}
            options={[
              { value: 'all', label: 'All members' },
              ...members.map((m) => ({
                value: String(m.id),
                // Former members' campaigns stay attributed to the team they
                // ran in, so they stay selectable — greyed to show they have
                // left, never removed, or the per-member counts wouldn't sum
                // to the team total. Same treatment as Workflows.
                label: (
                  <span className={m.is_member ? undefined : 'text-muted-foreground dark:text-[#8a8f98]'}>
                    {m.name} ({m.campaign_count})
                  </span>
                ),
                description: m.is_member ? m.email : `${m.email} — former member`,
              })),
            ]}
          />
        </div>
      )}

      {/* Campaign List */}
      <div className="space-y-4">
        {isLoading ? (
          <div className="flex items-center justify-center py-20">
            <CircleNotch className="h-8 w-8 animate-spin text-[#5e6ad2] dark:text-[#a5b4fc]" weight="bold" />
          </div>
        ) : campaigns.length === 0 ? (
          /* Empty State (§24) */
          <Card variant="default" className="rounded-lg border-border/50 dark:bg-white/[0.02] dark:border-white/[0.08]">
            <CardContent className="p-14 text-center">
              <div className="max-w-md mx-auto">
                <div className="h-12 w-12 rounded-md bg-muted/70 dark:bg-white/[0.04] dark:border dark:border-white/[0.05] flex items-center justify-center mx-auto mb-4">
                  <PaperPlaneTilt className="h-5 w-5 text-muted-foreground dark:text-[#8a8f98]" weight="regular" />
                </div>
                <h3
                  className="text-foreground dark:text-[#f7f8f8] mb-2"
                  style={{ fontSize: '20px', fontWeight: 590, lineHeight: 1.33, letterSpacing: '-0.24px' }}
                >
                  Schedule your first campaign
                </h3>
                <p
                  className="text-muted-foreground dark:text-[#8a8f98] mb-6 leading-relaxed"
                  style={{ fontSize: '13px', letterSpacing: '-0.13px' }}
                >
                  Pick a workflow, choose an audience, and set when it starts sending.
                </p>
                <Button
                  variant="default"
                  size="sm"
                  icon={<Calendar className="h-4 w-4" weight="regular" />}
                  onClick={() => setShowLaunchModal(true)}
                  disabled={planLapsed}
                  title={lapsedTitle}
                >
                  Launch campaign
                </Button>
              </div>
            </CardContent>
          </Card>
        ) : (
          /* Campaign Cards (§22 list-row chrome) */
          campaigns.map((campaign) => {
            // Chip, badge and glyph all come from the one §60 map. The old
            // local table gave `completed` a muted chip beside an indigo badge,
            // and fell through to an indigo paper-plane for `stopped`/`failed`
            // — a dead campaign looked like it was sending.
            const status = campaignStatusMeta(campaign.status)
            // A rejected row explains itself on hover: the approver's reason
            // (spec 5.8) alongside any blocking error already recorded.
            const rejectionNote =
              campaign.status === 'rejected' && campaign.approval?.reason
                ? 'Rejected: ' + campaign.approval.reason
                : null
            const statusTooltip = [campaign.last_error_reason, rejectionNote].filter(Boolean).join('. ')
            return (
            <Card
              key={campaign.id}
              variant="default"
              className="group relative overflow-hidden rounded-lg border-border/50 hover:bg-muted/40 dark:bg-white/[0.02] dark:border-white/[0.08] dark:hover:bg-white/[0.03] transition-colors duration-150 cursor-pointer"
              onClick={() => navigate(`/campaigns/${campaign.id}`)}
            >
              {/* Soft top-right ambient — subtle indigo halo for depth */}
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{ backgroundImage: 'radial-gradient(circle at top right, rgba(94,106,210,0.08), transparent 60%)' }}
              />
              <CardContent className="relative p-0">
                <div className="flex items-center px-5 py-4 gap-4">
                  {/* Leading status chip — visual rhythm + status-at-a-glance */}
                  <div
                    className={cn('h-10 w-10 rounded-md flex items-center justify-center flex-shrink-0', status.iconTint.bg)}
                    aria-hidden="true"
                  >
                    <status.Icon className={cn('h-4 w-4', status.iconTint.fg, status.iconNudge)} weight="regular" />
                  </div>

                  {/* Middle: Info */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1.5">
                      <h3
                        className="text-foreground dark:text-[#f7f8f8] truncate group-hover:text-[#5e6ad2] dark:group-hover:text-[#a5b4fc] transition-colors duration-150"
                        style={{ fontSize: '15px', fontWeight: 510, letterSpacing: '-0.182px' }}
                      >
                        {campaign.name}
                      </h3>
                      {statusTooltip ? (
                        <Tooltip label={statusTooltip}>
                          <span
                            className={cn('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full uppercase cursor-default', status.chipClass)}
                            style={{ fontSize: '10px', fontWeight: 590, letterSpacing: '0.06em' }}
                          >
                            <WarningCircle weight="fill" className="h-2.5 w-2.5 shrink-0" />
                            {status.label}
                          </span>
                        </Tooltip>
                      ) : (
                        <span
                          className={cn('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full uppercase', status.chipClass)}
                          style={{ fontSize: '10px', fontWeight: 590, letterSpacing: '0.06em' }}
                        >
                          <span className={cn('h-1.5 w-1.5 rounded-full', status.dotClass)} />
                          {status.label}
                        </span>
                      )}
                      {campaign.workflow_name && (
                        <span
                          className="inline-flex items-center px-2 py-0.5 rounded-full bg-muted/60 text-muted-foreground border border-border/50 dark:bg-white/[0.04] dark:text-[#8a8f98] dark:border-white/[0.06]"
                          style={{ fontSize: '11px', fontWeight: 510, letterSpacing: '-0.1px' }}
                        >
                          {campaign.workflow_name}
                        </span>
                      )}
                    </div>
                    {campaign.description && (
                      <p
                        className="text-muted-foreground dark:text-[#8a8f98] truncate mb-2"
                        style={{ fontSize: '13px', letterSpacing: '-0.13px' }}
                      >
                        {campaign.description}
                      </p>
                    )}
                    <div
                      className="flex items-center gap-4 flex-wrap text-muted-foreground dark:text-[#8a8f98] tabular-nums"
                      style={{ fontSize: '11px', fontWeight: 510, letterSpacing: '-0.1px' }}
                    >
                      <span className="inline-flex items-center gap-1">
                        <UsersThree className="h-3 w-3" weight="regular" />
                        {campaign.total_recipients} recipients
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <Envelope className="h-3 w-3" weight="regular" />
                        {campaign.emails_sent} sent
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <Eye className="h-3 w-3" weight="regular" />
                        {campaign.emails_opened} opened
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <CursorClick className="h-3 w-3" weight="regular" />
                        {campaign.emails_clicked} clicked
                      </span>
                      <span className="inline-flex items-center gap-1 text-[#5e6ad2] dark:text-[#a5b4fc]">
                        <ArrowBendUpLeft className="h-3 w-3" weight="regular" />
                        {campaign.emails_replied} replied ({campaign.reply_rate.toFixed(1)}%)
                      </span>
                    </div>
                    {campaign.scheduled_start && (
                      <p
                        className="text-muted-foreground/80 dark:text-[#62666d] mt-1.5"
                        style={{ fontSize: '11px', letterSpacing: '-0.1px' }}
                      >
                        {campaign.actual_start ? 'Started' : 'Scheduled'}{' '}
                        {formatDistanceToNow(new Date(campaign.actual_start || campaign.scheduled_start), { addSuffix: true })}
                      </p>
                    )}
                  </div>

                  {/* Right: Actions (§20 always-visible) */}
                  <div className="flex items-center gap-1.5 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => navigate(`/campaigns/${campaign.id}`)}
                      icon={<Eye className="h-4 w-4" weight="regular" />}
                    >
                      View
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      aria-label="Campaign actions"
                      onClick={(e) => toggleMenu(campaign.id, e)}
                    >
                      <DotsThree className="h-4 w-4" weight="bold" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
            )
          })
        )}
      </div>

      {/* Pagination — uses stats.total (full set) so it stays correct even
          though the list endpoint returns one page at a time. */}
      {!isLoading && stats.total > PAGE_SIZE && (() => {
        const totalPages = Math.ceil(stats.total / PAGE_SIZE)
        const currentPage = Math.min(page, totalPages)
        const startItem = (currentPage - 1) * PAGE_SIZE + 1
        const endItem = Math.min(currentPage * PAGE_SIZE, stats.total)

        const getPageNumbers = () => {
          const pages: (number | 'ellipsis')[] = []
          if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) pages.push(i)
          } else {
            pages.push(1)
            if (currentPage > 3) pages.push('ellipsis')
            for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
              pages.push(i)
            }
            if (currentPage < totalPages - 2) pages.push('ellipsis')
            pages.push(totalPages)
          }
          return pages
        }

        return (
          <div className="flex items-center justify-between py-2">
            <p
              className="text-muted-foreground dark:text-[#8a8f98]"
              style={{ fontSize: '12px', letterSpacing: '-0.1px' }}
            >
              <span className="text-foreground dark:text-[#f7f8f8] font-medium tabular-nums">{startItem}-{endItem}</span> of{' '}
              <span className="text-foreground dark:text-[#f7f8f8] font-medium tabular-nums">{stats.total}</span> campaigns
            </p>
            <div className="flex items-center gap-1">
              <button
                disabled={currentPage <= 1}
                onClick={() => goToPage(currentPage - 1)}
                className="p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/40 disabled:opacity-30 disabled:cursor-not-allowed transition-colors duration-100 dark:text-[#8a8f98] dark:hover:text-[#f7f8f8] dark:hover:bg-white/[0.05]"
                aria-label="Previous page"
              >
                <CaretLeft className="h-4 w-4" />
              </button>
              {getPageNumbers().map((p, idx) =>
                p === 'ellipsis' ? (
                  <span key={`ellipsis-${idx}`} className="px-1.5 text-muted-foreground dark:text-[#62666d]" style={{ fontSize: '12px' }}>…</span>
                ) : (
                  <button
                    key={p}
                    onClick={() => goToPage(p)}
                    className={cn(
                      'h-7 min-w-[1.75rem] px-2 rounded-md transition-colors duration-100 tabular-nums',
                      p === currentPage
                        ? 'bg-[#5e6ad2] text-white shadow-sm dark:bg-[#5e6ad2]'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted/40 dark:text-[#8a8f98] dark:hover:text-[#f7f8f8] dark:hover:bg-white/[0.05]',
                    )}
                    style={{ fontSize: '12px', fontWeight: 510, letterSpacing: '-0.1px' }}
                  >
                    {p}
                  </button>
                ),
              )}
              <button
                disabled={currentPage >= totalPages}
                onClick={() => goToPage(currentPage + 1)}
                className="p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/40 disabled:opacity-30 disabled:cursor-not-allowed transition-colors duration-100 dark:text-[#8a8f98] dark:hover:text-[#f7f8f8] dark:hover:bg-white/[0.05]"
                aria-label="Next page"
              >
                <CaretRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        )
      })()}

      {/* Launch Campaign Modal */}
      <LaunchCampaignModal
        isOpen={showLaunchModal}
        onClose={() => setShowLaunchModal(false)}
        onSuccess={() => {
          setPage(1)
          fetchCampaigns(0, PAGE_SIZE)
          fetchStats()
          setShowLaunchModal(false)
        }}
      />

      {/* AI Campaign Wizard */}
      <AICampaignWizard
        isOpen={showAIWizard}
        onClose={() => { setShowAIWizard(false); setAiInitialPrompt(undefined) }}
        onSuccess={() => {
          setPage(1)
          fetchCampaigns(0, PAGE_SIZE)
          fetchStats()
          setShowAIWizard(false)
          setAiInitialPrompt(undefined)
        }}
        initialPrompt={aiInitialPrompt}
      />

      {/* Campaign row action menu — portaled (§19) */}
      {openMenu != null && menuCoords && (() => {
        const campaign = campaigns.find(c => c.id === openMenu)
        if (!campaign) return null
        return createPortal(
          <>
            {/* z-80/81 is the page-level menu band (§59). This used to sit at
                z-[110]/[111], the band reserved for portals opened from inside
                a modal, so a row menu could paint over a dialog. */}
            <div className="fixed inset-0 z-[80]" onClick={closeMenu} aria-hidden="true" />
            <motion.div
              role="menu"
              initial={{ opacity: 0, y: -4, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.15, ease: [0.16, 1, 0.3, 1] }}
              style={{ position: 'fixed', top: menuCoords.top, right: menuCoords.right }}
              className="z-[81] w-52 rounded-lg bg-card border border-border/60 shadow-lg overflow-hidden py-1 dark:bg-[#191a1b] dark:border-white/[0.08]"
            >
              {campaign.status === 'scheduled' && canLaunch && (
                <button
                  role="menuitem"
                  type="button"
                  className="w-full flex items-center gap-2 px-2.5 py-2 mx-1 my-0.5 rounded-md text-foreground hover:bg-accent/40 dark:text-[#d0d6e0] dark:hover:bg-white/[0.04] transition-colors duration-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ fontSize: '13px', fontWeight: 510, letterSpacing: '-0.13px', width: 'calc(100% - 0.5rem)' }}
                  onClick={() => requestLaunch(campaign.id)}
                  disabled={planLapsed}
                  title={lapsedTitle}
                >
                  <Rocket className="h-4 w-4" weight="regular" />
                  {launchIsRequest ? 'Request launch' : 'Launch now'}
                </button>
              )}
              {campaign.status === 'running' && canPauseStop && (
                <button
                  role="menuitem"
                  type="button"
                  className="w-full flex items-center gap-2 px-2.5 py-2 mx-1 my-0.5 rounded-md text-foreground hover:bg-accent/40 dark:text-[#d0d6e0] dark:hover:bg-white/[0.04] transition-colors duration-100"
                  style={{ fontSize: '13px', fontWeight: 510, letterSpacing: '-0.13px', width: 'calc(100% - 0.5rem)' }}
                  onClick={() => handlePause(campaign.id)}
                >
                  <Pause className="h-4 w-4" weight="regular" />
                  Pause campaign
                </button>
              )}
              {campaign.status === 'paused' && canPauseStop && (
                <button
                  role="menuitem"
                  type="button"
                  className="w-full flex items-center gap-2 px-2.5 py-2 mx-1 my-0.5 rounded-md text-foreground hover:bg-accent/40 dark:text-[#d0d6e0] dark:hover:bg-white/[0.04] transition-colors duration-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ fontSize: '13px', fontWeight: 510, letterSpacing: '-0.13px', width: 'calc(100% - 0.5rem)' }}
                  onClick={() => handleResume(campaign.id)}
                  disabled={planLapsed}
                  title={lapsedTitle}
                >
                  <Play className="h-4 w-4" weight="regular" />
                  Resume campaign
                </button>
              )}
              {(campaign.status === 'scheduled' || campaign.status === 'running' || campaign.status === 'paused') && canPauseStop && (
                <div className="my-1 h-px bg-border/50 dark:bg-white/[0.06]" />
              )}
              {canPauseStop && (
                <button
                  role="menuitem"
                  type="button"
                  className="w-full flex items-center gap-2 px-2.5 py-2 mx-1 my-0.5 rounded-md text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-500/[0.08] transition-colors duration-100"
                  style={{ fontSize: '13px', fontWeight: 510, letterSpacing: '-0.13px', width: 'calc(100% - 0.5rem)' }}
                  onClick={() => handleDelete(campaign.id)}
                >
                  <Trash className="h-4 w-4" weight="regular" />
                  Delete
                </button>
              )}
            </motion.div>
          </>,
          document.body,
        )
      })()}

      {/* Launch confirm — sending is irreversible, so it gets the same second
          act as deleting (§16). Previously one menu click started the send. */}
      <ConfirmDialog
        open={pendingLaunchId != null}
        title={launchIsRequest ? 'Request approval to launch?' : 'Start sending now?'}
        description={(() => {
          const c = campaigns.find(x => x.id === pendingLaunchId)
          const recipients = c?.total_recipients ?? 0
          if (launchIsRequest) {
            return c
              ? `"${c.name}" (${recipients.toLocaleString()} ${recipients === 1 ? 'recipient' : 'recipients'}) will be sent to an Owner, Admin, or Manager for approval. It will not send until someone approves it.`
              : 'This campaign will be sent for approval before it can start sending.'
          }
          return c
            ? `"${c.name}" will start sending to ${recipients.toLocaleString()} ${recipients === 1 ? 'recipient' : 'recipients'} immediately, ahead of its scheduled start. Sent email cannot be recalled.`
            : 'This campaign will start sending immediately. Sent email cannot be recalled.'
        })()}
        confirmLabel={launchIsRequest ? 'Request approval' : 'Launch now'}
        cancelLabel="Cancel"
        loading={isLaunching}
        onConfirm={confirmLaunch}
        onCancel={() => !isLaunching && setPendingLaunchId(null)}
      />

      {/* Delete confirm */}
      <ConfirmDialog
        open={pendingDeleteId != null}
        title="Delete campaign"
        description="Are you sure you want to delete this campaign? This action cannot be undone."
        confirmLabel="Delete"
        cancelLabel="Cancel"
        tone="destructive"
        loading={isDeleting}
        onConfirm={confirmDelete}
        onCancel={() => !isDeleting && setPendingDeleteId(null)}
      />
    </div>
  )
}

export default CampaignsPage
